import axios from "axios";
import {useQueryClient} from "react-query";
import {apiUrl} from "../../config/api";
import {addAuthToFetchOpts} from "../../config/queryopts";
import {useMutationWithAuthentication} from "../index";


export const UpdateCompanyConfigFetcher = (accessToken, {companyId, params}) => {
  return axios.put(`${apiUrl}/operations/companies/${companyId}/config/customer`, params, addAuthToFetchOpts(accessToken, {})).then(res => res.data);
}


export const useUpdateCompanyConfigMutation = (fetcher = UpdateCompanyConfigFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['update-company-config-customer'],
    (accessToken, params) => fetcher(accessToken, params),
    {onSuccess: () => queryClient.invalidateQueries('update-company-config-customer')}
  )
}
